export default __webpack_public_path__ + "fonts/Gotham-Bold.6ffd084f4939469ee248dddd0792b426.ttf";